import styled from 'styled-components'

const CopyText = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 20px;
`
const CopyButton = styled.div`
  cursor: pointer;
  opacity: 0.7
  position: absolute;
  margin-top: 2px;
  top: 8px;
  right: 34px;
  &:hover {
    opacity: 0.6;
  }
`

export default {
  CopyText,
  CopyButton,
}
